import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GoalCategoryItem {
  id: number;
  category_name: string;
  status: string;
  createdon: string;
  createdby: string;
}

export interface GoalSubCategoryItem {
  id: number;
  sub_category_name: string;
  category_name: string;
  status: string;
  createdon: string;
  createdby: string;
}

interface GoalState {
  categories: GoalCategoryItem[];
  subCategories: GoalSubCategoryItem[];

  goalSuccessMsg: {
    message: string;
    id: string | number;
  };

  goalErrorMsg: {
    message: string;
    id: string | number;
  };

  loading: boolean;
}

export const initialState: GoalState = {
  categories: [],
  subCategories: [],   

  goalSuccessMsg: { message: "", id: "" },
  goalErrorMsg: { message: "", id: "" },

  loading: false,
};

const goalSlice = createSlice({
  name: "goal",
  initialState,
  reducers: {
    fetchGoalCategories(
      state,
      action: PayloadAction<GoalCategoryItem[]>
    ) {
      state.categories = action.payload || [];
    },

    fetchGoalSubCategories(
      state,
      action: PayloadAction<GoalSubCategoryItem[]>
    ) {
      state.subCategories = action.payload || [];
    },

    goalSuccessMsg(state, action: PayloadAction<any>) {
      state.goalSuccessMsg = action.payload;
    },

    goalErrorMsg(state, action: PayloadAction<any>) {
      state.goalErrorMsg = action.payload;
    },

    setGoalLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchGoalCategories,
  fetchGoalSubCategories,
  goalSuccessMsg,
  goalErrorMsg,
  setGoalLoader,
} = goalSlice.actions;

export default goalSlice.reducer;
